<template>
  <el-row>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-col :span="8">
        <el-form-item label="客户编码" prop="fNumber">
          <el-input v-model="form.fNumber" disabled />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="客户名称" prop="fName">
          <el-input v-model="form.fName" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="开票名称" prop="fBillingName">
          <el-input v-model="form.fBillingName" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="收货人" prop="fName_sh">
          <el-input v-model="form.fName_sh" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="联系电话" prop="fPhone">
          <el-input v-model="form.fPhone" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="区域" prop="fRegionID">
          <el-select-ex
            v-model="form.fRegionID"
            url="BasicInformation/Region/RegionEntry"
            label-field="fName"
            style="width: 100%"
            value-field="fRegionID"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="收货地址" prop="fAddress_sh">
          <el-input v-model="form.fAddress_sh" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="经营许可号" prop="fBusinessNo">
          <el-input v-model="form.fBusinessNo" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="经营地址" prop="fAddress_jy">
          <el-input v-model="form.fAddress_jy" />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="简介" prop="fDes">
          <el-input v-model="form.fDes" type="textarea" :rows="3" />
        </el-form-item>
      </el-col>
    </el-form>
  </el-row>
</template>

<script>
export default {
  props: {
    form: Object,
  },
  data: function () {
    return {
      rules: {
        fName: [{ required: true, message: "必填项", trigger: "change" }],
        fBillingName: [
          { required: true, message: "必填项", trigger: "change" },
        ],
        fRegion: [{ required: true, message: "必填项", trigger: "change" }],
        fBusinessNo: [{ required: true, message: "必填项", trigger: "change" }],
        fAddress_jy: [{ required: true, message: "必填项", trigger: "change" }],
        fRegionID: [{ required: true, message: "必填项", trigger: "change" }],
      },
    };
  },
  methods: {
    submit: function (onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = Object.assign({}, this.form);
          onValid(data);
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style>
</style>
